import { Inject, Injectable } from '@angular/core';
import { LoggerService } from '../../../../common/services/logger/logger.service';
import { TrackingService } from '../../../../common/services/tracking/tracking.service';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { MessageBusService } from '../../../../common/services/message-bus/message-bus.service';
import { MessageType } from '../../../../common/services/message-bus/message';
import { CoolHttp } from '@angular-cool/http';
import { ENVIRONMENT } from '../../../../common/services/injection-tokens';
import { Environment } from '../../../../../environments/environment.interface';
import { TranslationService } from '../translation/translation.service';

export function startupServiceFactory(provider: StartupService) {
  return () => provider.setupAsync();
}

@Injectable()
export class StartupService {
  constructor(
    @Inject(ENVIRONMENT) private _environment: Environment,
    private _translationService: TranslationService,
    private _trackingService: TrackingService,
    private _loggerService: LoggerService,
    private _messageBus: MessageBusService,
    private _http: CoolHttp,
    private _router: Router,
  ) {

  }

  public async setupAsync() {
    this._loggerService.initialize();

    this._setupHttp();

    this._translationService.setup();

    this._trackingService.initialize();

    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          const routeRoot = this._router.routerState.snapshot.root;

          let route: ActivatedRouteSnapshot = routeRoot.firstChild!;

          while (route?.firstChild) {
            route = route.firstChild;
          }

          return route;
        }),
      )
      .subscribe((route: ActivatedRouteSnapshot) => {
        this._messageBus.dispatch({ type: MessageType.PageView, payload: { page: route.data?.page } });
      });
  }

  private _setupHttp() {
    this._http.setWithCredentials(true);
    this._http.registerBaseUrl(this._environment.backendUrl);
  }
}
